export default {
  title: {
    en: 'Skip to recommendations',
  },
}
